import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47759238"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "no-config" }
const _hoisted_2 = { class: "error-page" }
const _hoisted_3 = { class: "error-img" }
const _hoisted_4 = ["innerHTML"]

import ErrorImg from '@/components/Common/Images/ErrorImg.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ErrorImg)
      ]),
      _createElementVNode("p", {
        class: "error-message",
        innerHTML: _ctx.$t('error.APP_ERROR')
      }, null, 8, _hoisted_4)
    ])
  ]))
}
}

})